"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../../utils");

var _default = function _default() {
  var initialState = {};

  var getEntity = function (state, entity) {
    if (state === void 0) {
      state = initialState;
    }

    return state[entity] || {};
  };

  var getDetail = function (state, entity, entityId) {
    if (state === void 0) {
      state = initialState;
    }

    return getEntity(state, entity)[entityId];
  };

  return {
    initialState,
    getEntity,
    getDetail,
    getList: function getList(state, entity, entityIdList) {
      if (state === void 0) {
        state = initialState;
      }

      var ids = entityIdList || Object.keys(getEntity(state, entity));
      var entityDetailList = ids.map(function (entityId) {
        return getDetail(state, entity, entityId);
      });
      return entityDetailList.filter(_utils.isObject);
    }
  };
};

exports.default = _default;